import fetch from '@/utils/fetch'

//
export function getAllowSaleList (data) {
  return fetch({
    url: '/website/universal/search/supplier-list',
    method: 'post',
    data
  })
}

// 获取景点详情
export function getTripDetail (id) {
  return fetch({
    url: `/ows/trip/industry/detail/${id}`,
    method: 'post'
  })
}

// 获取产品列表
export function getProductlist (data) {
  return fetch({
    url: '/ows/trip/goods/applet-home-list',
    method: 'post',
    data
  })
}

// 获取产品详情
export function getProductDetail (data) {
  return fetch({
    url: '/partner/trip/goods/supplier-detail',
    method: 'post',
    data
  })
}

// 获取分时段
export function findIntervalList (data) {
  return fetch({
    url: '/ows/interval/find-interval-list',
    method: 'post',
    data
  })
}

// 获取景点id所有分时段
export function findIntervalListByIndustry (data) {
  return fetch({
    url: '/ows/interval/find-interval-list-industry',
    method: 'post',
    data
  })
}

// 获取分时段配置
export function getInfo (data) {
  return fetch({
    url: '/interval/reservation-config/info',
    method: 'post'
  })
}

// 获取可退的票
export function getTripTicketRefund (data) {
  return fetch({
    url: '/trip/ticket/get-ticket-for-refund',
    method: 'post',
    data
  })
}

// 门票退款
export function tripRefund (data) {
  return fetch({
    url: '/ows/trip/order/refund/refund',
    method: 'post',
    data
  })
}

// 门票取消预约
export function tripCancel (data) {
  return fetch({
    url: '/ows/trip/order/cancel',
    method: 'post',
    data
  })
}
